import { Link } from "react-router-dom";
import classes from "./BackToLoginBtn.module.css";
import arrowLeft from "../../../images/ArrowLeft.svg";

export function BackToLoginBtn({ onClick }) {
  return (
    <Link
      className={classes.backToLogin}
      to={"/login"}
      onClick={onClick ? onClick : ""}
    >
      <img src={arrowLeft} alt="" /> <span>Back to login</span>
    </Link>
  );
}
